import { LongAktenzeichenRenderer } from './long-aktenzeichen-renderer';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ShortAktenzeichenRenderer } from './short-aktenzeichen-renderer';
import { AktenzeichenRenderer } from './aktenzeichen-renderer';
import { ApiRootFacade } from '@schir-int-client/api-root';
import { isNil } from 'lodash-es';

@Injectable({
	providedIn: 'root',
})
export class AktenzeichenRendererProvider {
	private renderer: AktenzeichenRenderer = new LongAktenzeichenRenderer();

	constructor(private apiRootFacade: ApiRootFacade) {
		this.apiRootFacade
			.getCurrentApiRoot()
			.pipe(filter(apiRoot => !isNil(apiRoot)))
			.subscribe(apiRoot => {
				this.renderer = apiRoot.shortAktenzeichen
					? new ShortAktenzeichenRenderer()
					: new LongAktenzeichenRenderer();
			});
	}

	getRenderer(): AktenzeichenRenderer {
		return this.renderer;
	}
}
